export default __webpack_public_path__ + "static/media/investments.3c26eca0.png";